import React, { useEffect, useState } from "react";

//Import Breadcrumb
import { Icon } from "@iconify/react/dist/iconify.js";
import { Box, Divider, Grid, Stack } from "@mui/material";
import { connect, useDispatch } from 'react-redux';
import { useNavigate, useParams } from "react-router-dom";
import { Container } from "reactstrap";
import Label from "../../components/Common/Label";
import LoadingDialog from "../../components/Common/LoadingDialog";
import Notification from "../../components/Common/Notification";
import Helpers from "../../helpers/helpers";
import CustomButton from "../../components/Form/CustomButton";
import RenderPopOverButton from "../../components/Form/RenderPopOverButton";
import CustomTextField from "../../components/Form/CustomTextField";
import ImportantNotice from "../../components/Common/ImportantNotice";
import TableStyle2 from "../../components/Common/TableStyle2";
import AppDialog from "../../components/Common/AppDialog";
import TablePageControl from "../../components/Common/TablePageControl";
import AccessoriesInfoModal from "./modal/AccessoriesInfoModal";
import { addRemark, bulkAction, bulkDeleteAccessory, getAccessoryDetails, resetAccessoryActionState, resetAccessoryState } from "../../store/actions";
import AppAttachmentDialog from "../../components/Common/AppAttachmentDialog";
import AccessoriesMarkSold from "./modal/AccessoriesSold";
import AccessoriesMoveDraft from "./modal/AccessoriesMoveDraft";
import AccessoriesPublish from "./modal/AccessoriesPublish";


const AccessoryDetails = ({ title, userPermission, accessoryDetails, accessoryAddRemark, leftSideBarType, windowWidth, accessoryBulkAction, accessoryBulkDelete, error, accessoryDetailsCode }) => {
    const { ID } = useParams()
    const dispatch = useDispatch();
    const navigate = useNavigate();
    useEffect(() => {
        dispatch(resetAccessoryState());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const [loading, setIsLoading] = useState(false);
    const [remark, setRemark] = useState();
    const [creatable, setCreatable] = useState(true);
    const [editable, setEditable] = useState(true);
    const [exportable, setExportable] = useState(true);
    const [deletable, setDeletable] = useState(true);
    const [detailsOpen, setDetailsOpen] = useState(false);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [soldOpen, setSoldOpen] = useState(false);
    const [moveDraftOpen, setMoveDraftOpen] = useState(false);
    const [publishOpen, setPublishOpen] = useState(false);
    const [renewOpen, setRenewOpen] = useState(false);
    const [isImportantNoticeOpen, setIsImportantNoticeOpen] = useState(true);
    const [inquiryPage, setInquiryPage] = useState(1);
    const [inquiryLength, setInquiryLength] = useState(10);
    const [remarkPage, setRemarkPage] = useState(1);
    const [selectedDocument, setSelectedDocument] = useState(null);
    const [documentOpen, setDocumentOpen] = useState(false);
    const [remarkLength, setRemarkLength] = useState(10);
    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    useEffect(() => {
        if (userPermission?.length > 0) {
            userPermission?.includes("create-user") && setCreatable(true);
            userPermission?.includes("update-user") && setEditable(true);
            userPermission?.includes("export-user") && setExportable(true);
            userPermission?.includes("delete-user") && setDeletable(true);
        }
    }, [userPermission])

    useEffect(() => {
        if (accessoryAddRemark?.code === 'success') {
            setIsLoading(false);
            setRemark('');
            setNotification({
                open: true,
                type: 'success',
                msg: 'Remark added successfully.'
            });
            initData();
            dispatch(resetAccessoryActionState());
        }
    }, [accessoryAddRemark])

    useEffect(() => {
        if (accessoryBulkAction?.code === 'success') {
            moveDraftOpen && setMoveDraftOpen(false);
            publishOpen && setPublishOpen(false);
            soldOpen && setSoldOpen(false);
            setNotification({
                open: true,
                type: 'success',
                msg: accessoryBulkAction?.message || 'Accessory updated successfully.'
            });
            dispatch(resetAccessoryActionState());
            initData();
        }
    }, [accessoryBulkAction])

    useEffect(() => {
        if (accessoryBulkDelete?.code === 'success') {
            setNotification({ open: true, msg: accessoryBulkDelete?.message || 'Accessory deleted successfully', type: 'success' });
            setDeleteOpen(false);
            setTimeout(() => {
                setIsLoading(false);
                dispatch(resetAccessoryActionState());
                navigate('/accessories');
            }, 2000);

        }
    }, [accessoryBulkDelete])

    useEffect(() => {
        if (accessoryDetails?.id) {
            setIsLoading(false);
        }
    }, [accessoryDetails])

    useEffect(() => {
        if (ID) {
            initData();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ID]);

    const header = [
        {
            title: 'Date of Inquiry',
            accessor: (item, idx) => {
                return (item?.inquiry_date || '-')
            }
        },
        {
            title: 'User Name',
            accessor: (item, idx) => {
                return (item?.user_name || '-')
            }
        },
        {
            title: 'Contact',
            accessor: (item, idx) => {
                return (item?.contact_no || '-')
            }
        },
        {
            title: 'Inquiries Status',
            accessor: (item, idx) => {
                return (<Label.GeneralStatusLabel label={item?.status} list={Helpers.invoiceStatus} marginLeft={"0px"} />)
            }
        },
        {
            title: ' ',
            width: 250,
            accessor: (item, idx) => {
                return (
                    <>
                        {
                            item?.contact_no ?
                                <CustomButton
                                    title={
                                        <div className="d-flex align-items-center" style={{ color: 'white' }}>
                                            <Icon icon={'mingcute:whatsapp-fill'} style={{ marginRight: 10 }} />Contact Buyer
                                        </div>
                                    }
                                    press={() => { }} // link to whatsapp chat
                                    textColor={'white'}
                                    backgroundColor={'#59C825'}
                                />
                                : null
                        }
                    </>
                )
            }
        },
    ]

    const remarkHeader = [
        {
            title: 'Date',
            accessor: (item, idx) => {
                return (item?.created_at || '-')
            }
        },
        {
            title: 'Remark / Notes',
            width: '50%',
            accessor: (item, idx) => {
                return (
                    <div>
                        {item?.remark || '-'}
                        <div className="">
                            {
                                item?.attachments?.length > 0 && item?.attachments?.map((item, index) => {
                                    let fileType = item?.attachment_name ? '' : Helpers.getFileExtension(item?.base64);
                                    return (
                                        <div className='clickable-link' onClick={() => handleOpenDocument(item, index)} key={index}>
                                            {item?.attachment_name || `Attachment ${index + 1}.${fileType}`}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                )
            }
        },
        {
            title: 'Action By',
            accessor: (item, idx) => {
                return (item?.log_by || '-')
            }
        },
    ]

    const draftDropdown = [
        { iconName: 'solar:upload-minimalistic-linear', label: 'Publish', color: '#1D1B1B', onClick: () => { setPublishOpen(true) } },
        { iconName: 'solar:eye-linear', label: 'View Details', permission: deletable, onClick: () => { setDetailsOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete Draft', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const soldOutDropdown = [
        { iconName: 'solar:eye-linear', label: 'View Details', permission: deletable, onClick: () => { setDetailsOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const publishedDropdown = [
        { iconName: 'solar:eye-linear', label: 'View Details', permission: deletable, onClick: () => { setDetailsOpen(true) } },
        { iconName: 'solar:check-read-linear', label: 'Mark as Sold', permission: editable, onClick: () => { setSoldOpen(true) } },
        // { iconName: 'solar:archive-down-minimlistic-linear', label: 'Move to Draft', permission: editable, onClick: () => { setMoveDraftOpen(true) } },
        { iconName: 'solar:trash-bin-2-linear', label: 'Delete', color: '#D13536', permission: deletable, onClick: () => { setDeleteOpen(true) } },
    ]

    const initData = () => {
        dispatch(getAccessoryDetails({ id: ID }))
    }

    const handleSubmitRemark = () => {
        if (!remark) {
            setNotification({
                open: true,
                type: 'error',
                msg: 'Please enter remark before submitting.'
            });
            return;
        }
        setIsLoading(true);
        let payload = {
            id: ID,
            data: { remark: remark }
        }
        dispatch(addRemark(payload));
    }

    const handleOpenDocument = (attachment, idx) => {
        let fileType = Helpers.getFileExtension(attachment?.file_base64 || attachment?.attachment_base64);

        if (fileType === 'csv' || fileType === 'xls' || fileType === 'xlsx' || fileType === 'xlsm') {
            Helpers.handleDownloadDocument(attachment?.file_base64 || attachment?.attachment_base64, attachment?.file_name || attachment?.name || `attachment_${idx + 1}`, attachment?.file_name ? true : false);
        } else {
            setSelectedDocument({
                base64: attachment?.file_base64 || attachment?.attachment_base64,
                type: fileType,
                name: attachment?.file_name || attachment?.name || `attachment_${idx + 1}`
            });
            setDocumentOpen(true)
        }
    }

    const handleDelete = () => {
        setIsLoading(true);
        let payload = {
            ids: [ID]
        }
        dispatch(bulkDeleteAccessory(payload));
    }

    const handleMarkAsSold = () => {
        setIsLoading(true);
        let payload = {
            ids: [ID],
            status: 'sold'
        }
        dispatch(bulkAction(payload))
    }

    const handleMoveToDraft = () => {
        setIsLoading(true);
        let payload = {
            ids: [ID],
            status: 'draft'
        }
        dispatch(bulkAction(payload))
    }

    const handlePublish = () => {
        setIsLoading(true);
        let payload = {
            ids: [ID],
            status: 'published'
        }
        dispatch(bulkAction(payload))
    }

    const content = Helpers.noticeContentByStatus?.find((item) => item.status === accessoryDetails?.status);
    const renderNoticeSection = () => {
        if (!content || !isImportantNoticeOpen) return null;
        return (
            <ImportantNotice
                backgroundColor={content?.backgroundColor}
                color={content?.borderColor}
                iconColor={content?.iconColor}
                iconName={content?.iconName}
                message={
                    <>
                        <div className="text-bold mb-2">{content?.title}</div>
                        <div >{content?.description}</div>
                        {
                            content?.hasActionButton &&
                            <Box className="mt-3 align-items-center" sx={{ display: { lg: 'flex', md: 'block' }, marginTop: { md: 2, sm: 2, xs: 2 } }}>
                                <CustomButton
                                    title={'Renew Now'}
                                    press={() => { setRenewOpen(true) }}
                                    marginRight={10}
                                />
                                <CustomButton
                                    title={'Dismiss'}
                                    press={() => { setIsImportantNoticeOpen(false) }}
                                    backgroundColor={'#F9F9F9'}
                                    textColor={'#1D1B1B'}
                                    borderStyle={'1px solid #F9F9F9'}
                                />
                            </Box>
                        }
                    </>
                }
            />
        )
    }

    const renderGeneralTab = () => {
        return (
            <>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Grid container spacing={2}>
                                    <Grid item lg={7} md={12} sm={12}>
                                        <div className="header">
                                            {accessoryDetails?.info?.title || '-'}
                                        </div>
                                    </Grid>
                                    <Grid item lg={5} md={12} sm={12} >
                                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: { lg: 'flex-end', md: 'start' } }}>
                                            {
                                                // accessoryDetails?.status - published
                                                accessoryDetails?.status === 'Published' &&
                                                <CustomButton
                                                    title={<><span style={{ display: 'inline-flex', alignItems: 'center' }}><span style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><Icon icon="solar:square-top-down-linear" style={{ fontSize: 18 }} /></span>View on Marketplace</span></>}
                                                    backgroundColor="#F5F5F5"
                                                    textColor="#1D1B1B"
                                                    borderStyle="1px solid #F5F5F5"
                                                    press={() => window.open(accessoryDetails?.marketplace_url, '_blank')}
                                                    marginRight={10}
                                                />
                                            }
                                            <CustomButton
                                                title={<><span style={{ display: 'inline-flex', alignItems: 'center' }}><span style={{ marginRight: 8, display: 'flex', alignItems: 'center' }}><Icon icon="ri:pencil-line" style={{ fontSize: 18 }} /></span>Edit Accessory</span></>}
                                                backgroundColor="white"
                                                textColor="#1D1B1B"
                                                borderStyle="1px solid #1D1B1B"
                                                press={() => { navigate(`/edit-accessory/${ID}`) }}
                                            />
                                            {
                                                // accessoryDetails?.status - draft/published/inactive/soldout
                                                (accessoryDetails?.status === 'Draft' || accessoryDetails?.status === 'Published' || accessoryDetails?.status === 'Inactive' || accessoryDetails?.status === 'Sold') &&
                                                <RenderPopOverButton
                                                    items={accessoryDetails?.status === 'Draft' ? draftDropdown : accessoryDetails?.status === 'Sold' ? soldOutDropdown : publishedDropdown}
                                                />
                                            }
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                {renderNoticeSection()}
                            </Grid>
                            <Grid item container md={12} sm={12} xs={12} mt={(!content || !isImportantNoticeOpen) ? 0 : 2}>
                                <Grid item lg={2} md={2} sm={12} xs={12} className="subheader-2 p-2">
                                    <img src={accessoryDetails?.thumbnail_base64} style={{ width: '100%', height: 120, objectFit: 'contain' }} />
                                </Grid>
                                <Grid item lg={10} md={10} sm={12} xs={12} py={2} px={1}>
                                    <div className="text-bold font-size-18">{accessoryDetails?.name || '-'}</div>
                                    <div className="d-flex align-items-center my-2">
                                        <span className="price-text">${accessoryDetails?.selling_price || '-'}</span>
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Label.GeneralStatusLabel label={accessoryDetails?.status} list={Helpers.accessoryStatus} marginLeft={"0px"} />
                                        {
                                            (accessoryDetails?.status !== 'Draft' && accessoryDetails?.status !== 'Published') &&
                                            <div className="mx-3">
                                                <span className="subheader-2">Advert ID: </span>
                                                TRD660-SG-04521
                                            </div>
                                        }
                                        <div className={(accessoryDetails?.status !== 'Draft' && accessoryDetails?.status !== 'Published') ? "" : "mx-3"}>
                                            <span className="subheader-2">Listed On: </span>
                                            {accessoryDetails?.created_at || '-'}
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                            <Grid item sm={12}>
                                {renderAccessoryInfo()}
                            </Grid>
                        </Grid>
                    </Grid>
                    {renderTableSection()}
                </Grid>
            </>
        )
    }

    const renderAccessoryInfo = () => {
        return (
            <Box className="advert-info-container">
                <Grid container spacing={2}>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <div className="subheader-2">Total Inquiries</div>
                        <div>{accessoryDetails?.total_inquiries || '0'}</div>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <div className="subheader-2">Total Views</div>
                        <div>{accessoryDetails?.total_views || '0'}</div>
                    </Grid>
                    <Grid item lg={3} md={6} sm={6} xs={12}>
                        <div className="subheader-2">Total Likes</div>
                        <div>{accessoryDetails?.total_likes || '0'}</div>
                    </Grid>
                    {/* <Grid item lg={3} md={6} sm={6} xs={12}>
                        <div className="subheader-2">Total Boosts</div>
                        <div>-</div>
                    </Grid> */}
                </Grid>
            </Box>
        )
    }

    const renderTableSection = () => {
        return (
            <>
                <Grid item xs={12} pt={1}>
                    <div className="text-bold font-size-16 pb-4 d-flex align-items-center" >
                        Inquiries ({accessoryDetails?.items?.length || 0})
                    </div>
                    <TableStyle2
                        header={header}
                        tableData={[{ inquiry_date: '25 September 2024', contact_no: '91234567', status: 'new', user_name: 'John Doe' },]}
                    />
                    <TablePageControl
                        length={inquiryLength}
                        setLength={setInquiryLength}
                        page={inquiryPage}
                        setPage={setInquiryPage}
                        totalPage={1}
                    />
                </Grid>
                <Grid item xs={12} mt={3}>
                    <div className="text-bold font-size-16 pb-4 d-flex align-items-center" >
                        Remarks / Notes
                    </div>
                    <TableStyle2
                        header={remarkHeader}
                        tableData={accessoryDetails?.logs?.data || []}
                    />
                    <TablePageControl
                        length={remarkLength}
                        setLength={setRemarkLength}
                        page={remarkPage}
                        setPage={setInquiryPage}
                        totalPage={accessoryDetails?.logs?.last_page || 1}
                    />
                    <div className="mt-3">
                        <CustomTextField
                            values={remark}
                            placeholder={"Remarks / Notes"}
                            onChange={(e) => setRemark(e)}
                            multiline={true}
                            rows={4}
                        />
                    </div>
                    <CustomButton
                        title={'Submit'}
                        press={() => handleSubmitRemark()}
                        marginTop={10}
                    />
                </Grid>
            </>
        )
    }
    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: windowWidth <= 768 && leftSideBarType === 'condensed' ? 72 : 0 }}>
                <LoadingDialog open={loading || !accessoryDetailsCode?.code} />
                <Container fluid>
                    <Notification notification={notification} setNotification={setNotification} errors={error} />
                    {accessoryDetailsCode?.code && accessoryDetailsCode?.code !== "success" ?
                        <div className="d-flex align-items-center justify-content-center" style={{ height: '70vh' }}>
                            <div className="text-center">
                                <div className="header-2 pb-3">{accessoryDetailsCode?.message || "Something went wrong."}</div>
                                <CustomButton
                                    title={'Go to Accessories'}
                                    press={() => navigate('/accessories')}
                                    padding={20}
                                />
                            </div>
                        </div>

                        :
                        <Grid container spacing={2}>
                            <Grid item sm={12}>
                                <CustomButton
                                    title={
                                        <div className="d-flex align-items-center" style={{ fontWeight: 400 }}>
                                            <Icon icon={'fluent:chevron-left-20-regular'} style={{ marginRight: 10 }} />Back to listing
                                        </div>
                                    }
                                    borderRadius={"5px"}
                                    borderStyle={"0px"}
                                    backgroundColor={"transparent"}
                                    textColor={"#000000"}
                                    paddingInline={7}
                                    press={() => navigate(-1)}
                                />
                            </Grid>
                            <Grid item xs={12} pr={0} mr={0}>
                                <div className="px-2">{renderGeneralTab()}</div>
                            </Grid>
                        </Grid>}
                </Container>
                <AccessoriesInfoModal
                    open={detailsOpen}
                    close={() => setDetailsOpen(false)}
                    handleSubmit={() => { }}
                    windowWidth={windowWidth}
                    accessoryInfo={accessoryDetails || {}}
                />
                <AccessoriesMarkSold
                    open={soldOpen}
                    close={() => setSoldOpen(false)}
                    handleSubmit={() => { handleMarkAsSold() }}
                    windowWidth={windowWidth}
                />
                <AccessoriesMoveDraft
                    open={moveDraftOpen}
                    close={() => setMoveDraftOpen(false)}
                    handleSubmit={() => { handleMoveToDraft() }}
                    windowWidth={windowWidth}
                />
                <AccessoriesPublish
                    open={publishOpen}
                    close={() => setPublishOpen(false)}
                    handleSubmit={() => { handlePublish() }}
                    windowWidth={windowWidth}
                />
                <AppDialog
                    open={deleteOpen}
                    close={() => setDeleteOpen(false)}
                    title={`Delete ${accessoryDetails?.status === 'Draft' ? 'Draft' : 'Accessory'}`}
                    positiveTitle={'Delete'}
                    positiveButtonStyle={{ backgroundColor: '#D13536', color: 'white', borderRadius: 20, width: 'auto', border: '1px solid #D13536' }}
                    positivePress={() => handleDelete()}
                    cancelButton={true}
                    width={'40%'}
                    windowWidth={windowWidth}
                >
                    <div className="subheader-2">Are you sure to want to delete this {accessoryDetails?.status === 'Draft' ? 'draft' : 'accessory'}?</div>
                </AppDialog>
                <AppAttachmentDialog
                    open={documentOpen}
                    close={() => { setDocumentOpen(false); setSelectedDocument(null) }}
                    file={selectedDocument?.base64}
                    filename={selectedDocument?.name}
                    filetype={selectedDocument?.type}
                />
            </div>
        </React.Fragment >
    );
};

function mapStateToProps({ Login, Accessory, Layout }) {
    return {
        userData: Login?.verifyAdmin?.user?.data,
        userPermission: Login?.permissionArry,
        accessoryDetails: Accessory?.accessoryDetails?.data,
        accessoryAddRemark: Accessory?.accessoryAddRemark,
        accessoryBulkAction: Accessory?.accessoryBulkAction,
        accessoryBulkDelete: Accessory?.accessoryBulkDelete,
        leftSideBarType: Layout.leftSideBarType,
        error: Accessory?.error?.errors,
        windowWidth: Layout.currentWidth,
        accessoryDetailsCode: Accessory?.accessoryDetails
    };
}


export default connect(mapStateToProps)(AccessoryDetails);
